<script lang="ts" setup>
defineOptions({ inheritAttrs: false });

const model = defineModel<boolean>();

withDefaults(
  defineProps<{
    color?: string;
    flat?: boolean;
    hideDetails?: boolean | "auto";
  }>(),
  {
    color: "primary",
    flat: false,
    hideDetails: true,
  },
);
</script>

<template>
  <v-switch v-model="model" :color="color" :flat="flat" :hide-details="hideDetails" v-bind="$attrs">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps ?? {}" />
    </template>
  </v-switch>
</template>
